<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="tf-question">
        <span class="tf-bar tf-bar--xl"></span>
        <span class="tf-bar tf-bar--md"></span>
      </div>
      <div class="tf-counts">
        <div class="tf-count tf-count--true">
          <span class="material-symbols-rounded tf-icon">check</span>
          <span class="tf-count-label">TRUE</span>
          <div class="tf-track">
            <div class="tf-fill tf-fill--true"></div>
          </div>
          <span class="tf-num">18</span>
        </div>
        <div class="tf-count tf-count--false">
          <span class="material-symbols-rounded tf-icon">close</span>
          <span class="tf-count-label">FALSE</span>
          <div class="tf-track">
            <div class="tf-fill tf-fill--false"></div>
          </div>
          <span class="tf-num">7</span>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="tf-phone-q"></span>
      <div class="tf-phone-card">
        <span class="tf-bar tf-bar--md"></span>
        <span class="tf-bar tf-bar--xl"></span>
        <span class="tf-bar tf-bar--md"></span>
        <div class="tf-phone-indicators">
          <span class="tf-phone-no">
            <span class="material-symbols-rounded">close</span>
          </span>
          <span class="tf-phone-yes --active">
            <span class="material-symbols-rounded">check</span>
          </span>
        </div>
      </div>
      <div class="tf-phone-hint">
        Swipe right to agree
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewTrueFalse',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
})
</script>

<style scoped lang="scss">
.tf-bar {
  display: block; height: 6px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.tf-bar--xl { width: 70%; height: 8px; }
.tf-bar--md { width: 40%; }

.tf-question {
  display: flex; flex-direction: column; gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}
.tf-question .tf-bar:first-child { background: rgba(15, 15, 20, 0.2); }

.tf-counts {
  display: grid; gap: 8px;
}
.tf-count {
  display: grid;
  grid-template-columns: 18px auto 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
}
.tf-icon {
  font-size: 16px; padding: 2px;
  border-radius: 999px;
  display: grid; place-items: center;
}
.tf-count--true .tf-icon { background: var(--accent); color: white; }
.tf-count--false .tf-icon { background: rgba(15, 15, 20, 0.12); color: rgba(15, 15, 20, 0.6); }
.tf-count-label {
  font-size: 10px; font-weight: 800;
  letter-spacing: 0.08em;
  color: rgba(15, 15, 20, 0.55);
}
.tf-track {
  height: 10px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.06);
  overflow: hidden;
}
.tf-fill {
  height: 100%;
  border-radius: 999px;
  width: 0;
  animation: tf-grow 4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
.tf-fill--true { background: var(--accent); --tf-target: 72%; }
.tf-fill--false { background: rgba(15, 15, 20, 0.3); --tf-target: 28%; animation-delay: 200ms; }
.tf-num {
  font-size: 11px; font-weight: 800;
  color: rgba(15, 15, 20, 0.7);
  font-variant-numeric: tabular-nums;
}

/* ---- Audience phone ---- */
.tf-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.tf-phone-card {
  background: white;
  border: 1px solid rgba(15, 15, 20, 0.12);
  border-radius: 10px;
  padding: 14px 10px;
  display: flex; flex-direction: column; gap: 6px;
  position: relative;
  animation: tf-swipe 4s ease-in-out infinite;
}
.tf-phone-indicators {
  display: flex; justify-content: space-between;
  margin-top: 6px;
}
.tf-phone-no, .tf-phone-yes {
  width: 26px; height: 26px;
  border-radius: 999px;
  display: grid; place-items: center;
  background: rgba(15, 15, 20, 0.06);
  color: rgba(15, 15, 20, 0.4);
}
.tf-phone-no .material-symbols-rounded,
.tf-phone-yes .material-symbols-rounded { font-size: 16px; }
.tf-phone-yes.--active {
  background: var(--accent); color: white;
  animation: tf-pulse 4s ease-in-out infinite;
}
.tf-phone-hint {
  font-size: 10px; font-weight: 700;
  color: var(--accent);
  text-align: center;
  margin-top: 4px;
}

@keyframes tf-grow {
  0%, 12% { width: 0; }
  60%     { width: var(--tf-target, 50%); }
  92%, 100% { width: var(--tf-target, 50%); }
}
@keyframes tf-swipe {
  0%, 18%  { transform: translateX(0) rotate(0); }
  55%      { transform: translateX(14px) rotate(4deg); }
  85%, 100% { transform: translateX(0) rotate(0); }
}
@keyframes tf-pulse {
  0%, 35%  { transform: scale(1); }
  55%      { transform: scale(1.15); }
  80%, 100% { transform: scale(1); }
}

@media (prefers-reduced-motion: reduce) {
  .tf-fill, .tf-phone-card, .tf-phone-yes.--active { animation: none; }
  .tf-fill--true { width: 72%; }
  .tf-fill--false { width: 28%; }
}
</style>
